import { useState } from "react";
import Dropdown from "react-bootstrap/Dropdown";
import SessionTimer from "./SessionTimer";
import { FaCopy } from "react-icons/fa6";
import { ToastContainer, toast } from "react-toastify";
import { clearAuthSession } from "./RequireAuth";
import { CgProfile } from "react-icons/cg";
function Commonheader() {
    const username = sessionStorage.getItem("user_name");
    const userId = sessionStorage.getItem("user_id");

    const [progress, setProgress] = useState(100);

    const handleLogout = () => {
        clearAuthSession();
        window.location.href = "/";
    };
    const handleCopyUsername = () => {
        if (userId) {
            navigator.clipboard.writeText(userId);

            toast.success("User ID Copied Successfully", {
                theme: "colored",
                position: "top-right",
                autoClose: 2000,
                hideProgressBar: false,
            });

        }
    };



    return (
        <header className="top-header">
            <div className="par-logopart">
                <img src="../images/MAINLOGO.png" alt="" className="img-fluid" />

                <div className="paralogo-text">

                    <h4 className="mb-0">
                        COMMISSIONERATE OF HIGHER EDUCATION
                    </h4>
                    <p className="mb-0"> Government of Andhra Pradesh</p>
                </div>

            </div>

            {/* <div className="user-details">
                <div className="session-timer-container fancy-timer me-2">

                    <div className="timer-box">
                        <span className="timer-text">
                            <SessionTimer
                                onLogout={handleLogout}
                            />
                        </span>

                    </div>
                </div> */}
            <div className="user-details">
                <div className="session-timer-container fancy-timer me-2">
                    <div className="timer-box">
                        <span className="timer-icon">⏳</span>
                        <span className="timer-text">
                            <SessionTimer
                                onLogout={handleLogout}
                                onProgress={setProgress}
                            />
                        </span>
                    </div>

                    <div className="progress-bar-container">
                        <div
                            className={`fancy-progress ${progress <= 25 ? "danger" : ""}`}
                            style={{ width: `${progress}%` }}
                        />
                    </div>
                </div>

                <div className="user-drop-down">

                    <Dropdown align="end">
                        <Dropdown.Toggle variant="success">
                            <CgProfile size={25} />     Welcome to :-  {username} -({userId})
                        </Dropdown.Toggle>

                        <Dropdown.Menu>
                            <Dropdown.Item onClick={handleCopyUsername}>
                                User Id:   {userId}
                                <FaCopy style={{ marginLeft: "8px", cursor: "pointer" }} />
                            </Dropdown.Item>


                            <Dropdown.Divider />

                            <Dropdown.Item onClick={handleLogout}>
                                Logout
                            </Dropdown.Item>

                        </Dropdown.Menu>
                    </Dropdown>
                    <ToastContainer />

                </div>
            </div>
        </header >
    );
}

export default Commonheader;
